import { Chantier } from '../../../shared/models/chantier'
import { ChantierDto } from '../../data-access/http/dto/chantier.dto'
import { ModeIntervenant } from '../../../shared/models/enum/mode-intervenant.enum';

export class ChantierMapper {
  static dtoToModel(chantierDto: ChantierDto): Chantier  {
    if (!chantierDto) {
      return null;
    }
    return {
      code: chantierDto.code,
      nom: chantierDto.nom,
      facilitateur: chantierDto.facilitateur,
      engagementLg: chantierDto.engagementLg,
      displayName: chantierDto.code + ' - ' + chantierDto.nom,
      engagementTotal: chantierDto.engagementTotal,
      modeIntervenant: chantierDto.modeIntervenant as ModeIntervenant,
    }
  }

  static dtosToModels(chantierDtos: ChantierDto[]): Chantier[]  {
    if (!chantierDtos || !chantierDtos.length) {
      return [];
    }
    return chantierDtos.map(ChantierMapper.dtoToModel)
  }
}
